import {Button, Stack} from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';

interface IFullscreenImageActionsProps {
    onDownload: () => void;
}

export const FullscreenImageActions = ({onDownload}: IFullscreenImageActionsProps) => {
    return (
        <Stack
            direction="row"
            spacing={2}
            sx={{
                position: 'absolute',
                bottom: '-60px',
                left: '50%',
                transform: 'translateX(-50%)',
            }}
        >
            <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={onDownload}
            >
                Download
            </Button>
        </Stack>
    );
};
